import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledStack = styled(Stack)(({ theme }) => ({
  overflow: "hidden",
  height: "100%",
  width: "100%",
}));
